import { defineStore } from "pinia";
import { _GettersTree, _ActionsTree, StoreDefinition } from "pinia";
import { UseAudioList } from "@/@types/audio/use_audio";

interface StoreState {
  tracks: UseAudioList[];
  currentTrack: string;
  logic: {
    currentTime: number;
    duration: number;
    progress: number;
    repeat: boolean;
    isPlaying: boolean;
    autoplay: boolean;
  };
}

const state = (): StoreState => ({
  tracks: [],
  currentTrack: "",
  logic: {
    currentTime: 0,
    duration: 0,
    progress: 0,
    repeat: false,
    isPlaying: false,
    autoplay: true,
  },
});

const getters = {
  getCurrentTrack: (state: StoreState): string => {
    return state.currentTrack;
  },
  getTrackList: (state: StoreState): UseAudioList[] => {
    return state.tracks;
  },
  duration: (state: StoreState): number => {
    return state.logic.duration;
  },
  currentTime: (state: StoreState): number => {
    return state.logic.currentTime;
  },
  progress: (state: StoreState): number => {
    return state.logic.progress;
  },
  repeat: (state: StoreState): boolean => {
    return state.logic.repeat;
  },
  isPlaying: (state: StoreState): boolean => {
    return state.logic.isPlaying;
  },
  autoplay: (state: StoreState): boolean => {
    return state.logic.autoplay;
  },
};

interface CartActions {
  setCurrentTrack(id: string): void;
  setTracks(id: UseAudioList[]): void;
  setCurrentTime(time: number): void;
  setDuration(duration: number): void;
  setProgress(progress: number): void;
  destroyedPlayer(): void;
}
const actions = {
  setCurrentTrack(this: CartActions & StoreState, id: string) {
    this.currentTrack = id;
  },

  setTracks(this: CartActions & StoreState, tracks: UseAudioList[]) {
    this.tracks = tracks;
  },

  setCurrentTime(this: CartActions & StoreState, time: number) {
    this.logic.currentTime = time;

    if (this.logic.duration > 0) {
      this.logic.progress = (time / this.logic.duration) * 100;
    }
  },

  setDuration(this: CartActions & StoreState, duration: number) {
    this.logic.duration = duration;
  },

  setProgress(this: CartActions & StoreState, progress: number) {
    this.logic.progress = progress;
  },

  destroyedPlayer(this: CartActions & StoreState) {
    this.tracks = [];
    this.currentTrack = "";

    this.logic.currentTime = 0;
    this.logic.duration = 0;
    this.logic.progress = 0;
  },
  setPlayerState(this: CartActions & StoreState, ispaly: boolean) {
    this.logic.isPlaying = ispaly;
  },
  setAutoplay(this: CartActions & StoreState, autoplay: boolean) {
    this.logic.autoplay = autoplay;
  },
};

export const useAudio: StoreDefinition<
  string,
  StoreState,
  _GettersTree<StoreState>,
  _ActionsTree
> = defineStore<string, StoreState>("audios", {
  state,
  getters,
  actions,
});

export type ICartStore = ReturnType<typeof useAudio>;
